document.addEventListener('DOMContentLoaded', function() {
    
    // ==========================================
    // 1. PC端侧边栏折叠 (物理防重复绑定版)
    // ==========================================
    var mainSidebar = document.querySelector('.layout-side .sidebar');
    var mainToggleBtn = document.querySelector('.layout-side .toggle-btn');

    // 【核心修复】：检查按钮身上有没有 'has-listener' 这个标记
    if (mainToggleBtn && mainSidebar && !mainToggleBtn.hasAttribute('data-listener-bound')) {
        
        // 打个标记，下次代码再执行到这里，就不会再绑定了
        mainToggleBtn.setAttribute('data-listener-bound', 'true');

        mainToggleBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation(); 

            mainSidebar.classList.toggle('collapsed');
            console.log("PC端折叠状态:", mainSidebar.className);
        });
    }

    // ==========================================
    // 2. 手风琴菜单 (物理防重复绑定版)
    // ==========================================
    var accordionTitles = document.querySelectorAll('.accordion-title');
    
    accordionTitles.forEach(function(title) {
        // 【核心修复】：同理，检查有没有标记
        if (title.hasAttribute('data-listener-bound')) return;

        title.setAttribute('data-listener-bound', 'true');

        title.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var parentItem = title.closest('.accordion-item');
            if (parentItem) {
                parentItem.classList.toggle('active');
                console.log("手风琴状态:", parentItem.className);
            }
        });
    });

    // ==========================================
    // 3. 移动端侧边栏弹窗 (物理防重复绑定版)
    // ==========================================
    var mobileSidebarToggle = document.getElementById('mobileSidebarToggle');
    var mobileSidebarModal = document.getElementById('mobileSidebarModal');
    var mobileModalOverlay = document.getElementById('mobileModalOverlay');
    var mobileModalClose = document.getElementById('mobileModalClose');

    if (mobileSidebarToggle && mobileSidebarModal && !mobileSidebarToggle.hasAttribute('data-listener-bound')) {
        mobileSidebarToggle.setAttribute('data-listener-bound', 'true');
        
        mobileSidebarToggle.addEventListener('click', function() {
            mobileSidebarModal.classList.add('is-active');
            document.body.style.overflow = 'hidden'; 
        });
    }

    function closeMobileModal() {
        if (mobileSidebarModal) {
            mobileSidebarModal.classList.remove('is-active');
            document.body.style.overflow = ''; 
        }
    }

    if (mobileModalOverlay && !mobileModalOverlay.hasAttribute('data-listener-bound')) {
        mobileModalOverlay.setAttribute('data-listener-bound', 'true');
        mobileModalOverlay.addEventListener('click', closeMobileModal);
    }

    if (mobileModalClose && !mobileModalClose.hasAttribute('data-listener-bound')) {
        mobileModalClose.setAttribute('data-listener-bound', 'true');
        mobileModalClose.addEventListener('click', closeMobileModal);
    }

    window.addEventListener('resize', function() {
        if (window.innerWidth > 900) {
            closeMobileModal();
        }
    });
});
